import { BodyTextL, GRAY50 } from 'global-styles';
import styled from 'styled-components';

export const ItemDescription = styled(BodyTextL)`
  color: ${GRAY50};
`;
